import { useMutation } from '@apollo/client';
import type {
  InsertTagTypeWithOptionalGroupIdMutation,
  InsertTagTypeWithOptionalGroupIdMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertTagTypeWithOptionalGroupIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useInsertTagTypeWithOptionalGroupIdTRPC } from './useInsertTagTypeWithOptionalGroupIdTRPC';

export const useInsertTagTypeWithOptionalGroupId = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [insertTagTypeGraphQL, graphqlState] = useMutation(
    InsertTagTypeWithOptionalGroupIdDocument,
    {
      update: (cache) => {
        evictField(cache, 'tag_type');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useInsertTagTypeWithOptionalGroupIdTRPC();

  const insertTagType = async (
    variables: InsertTagTypeWithOptionalGroupIdMutationVariables
  ): Promise<InsertTagTypeWithOptionalGroupIdMutation> => {
    if (trpcEnabled) {
      return trpcMutation.insertTagType(variables);
    }

    const result = await insertTagTypeGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to insert tag type');
    }

    return result.data;
  };

  return {
    insertTagType,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
